import type { AuthProvider } from '@types';

export type LoginSessionAction =
  | 'wait'
  | 'show-login'
  | 'load-aal2-flow'
  | 'start-aal2-flow'
  | 'redirect-authenticated';

interface AuthenticationState {
  isAuthenticated: boolean;
  authProvider: AuthProvider;
  assuranceLevel?: string;
}

interface LoginSessionState extends AuthenticationState {
  isLoading: boolean;
  hasFlow: boolean;
}

/** AAL1 is an intermediate session and must never unlock application routes. */
export const isFullyAuthenticated = ({
  isAuthenticated,
  authProvider,
  assuranceLevel,
}: AuthenticationState): boolean => {
  if (!isAuthenticated) return false;
  if (authProvider === 'legacy') return true;
  return authProvider === 'ory' && assuranceLevel === 'aal2';
};

/** Decide how /login should handle the session discovered during application bootstrap. */
export const getLoginSessionAction = ({
  isLoading,
  isAuthenticated,
  authProvider,
  assuranceLevel,
  hasFlow,
}: LoginSessionState): LoginSessionAction => {
  if (isLoading) return 'wait';
  if (isFullyAuthenticated({ isAuthenticated, authProvider, assuranceLevel })) {
    return 'redirect-authenticated';
  }
  if (authProvider === 'ory' && assuranceLevel === 'aal1') {
    return hasFlow ? 'load-aal2-flow' : 'start-aal2-flow';
  }
  return 'show-login';
};
